import { gatewayInstance } from "../../axiosInstance";

export const getTax = async () => {
  try {
    const response = await gatewayInstance.get(
      "/financeservice/tax/tax/dropdown"
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const saveChargeType = async (data) => {
  try {
    const response = await gatewayInstance.post(
      "/financeservice/charge-Type/save",
      data
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const updateChargeType = async (data) => {
  try {
    const response = await gatewayInstance.put(
      "/financeservice/charge-Type/update",
      data
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const filterChargeTypes = async (data) => {
  try {
    const response = await gatewayInstance.post(
      "/financeservice/charge-Type/filter",
      data
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getChargeTypeDetails = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `/financeservice/charge-Type/get/${id}`
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const checkChargeTypeAlredyAvilable = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `/financeservice/charge-Type/is-available/charge-type`,data
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};
